module.exports = __webpack_public_path__ + "static/media/email_section_img.fb076128.jpg";